import { SUCCESS_LOADING_APPLICATIONS } from 'constants';

const initialState = {};

export default (state = initialState, action) => {
  switch(action.type){
    case SUCCESS_LOADING_APPLICATIONS:
      const { contactId } = action;

      return Object.assign({}, state, {
        [contactId] : action.payload.result.objects
      });

    default:
      return state;
  }
};